export const rubberMaterials = [
  {
    code: "EPDM",
    name: "EPDM (에틸렌-프로필렌 고무)",
    fullName: "Ethylene Propylene Diene Monomer",
    icon: "ri-sun-line",
    color: "bg-accent-500",
    properties: {
      내열성: "★★★★★ (최대 150℃)",
      내한성: "★★★★☆ (-50℃)",
      내후성: "★★★★★",
      내오존성: "★★★★★",
      내유성: "★☆☆☆☆",
      내마모성: "★★★☆☆",
      인장강도: "★★★☆☆ (8~20 MPa)",
    },
    features: [
      "내열성, 내후성, 내오존성이 매우 우수",
      "전기절연성이 뛰어남",
      "극성 용제에 대한 저항성 우수",
      "저온에서도 유연성 유지",
    ],
    applications: [
      "자동차 웨더스트립",
      "건축용 실링 가스켓",
      "열교환기 가스켓",
      "냉각수 호스",
      "전선 피복",
    ],
    desc: "가장 널리 사용되는 범용 고무 소재로, 특히 옥외 환경과 고온 환경에서 탁월한 성능을 발휘합니다. 내후성과 내오존성이 뛰어나 장기간 햇빛과 오존에 노출되는 환경에 적합합니다.",
  },
  {
    code: "NBR",
    name: "NBR (니트릴 고무)",
    fullName: "Acrylonitrile Butadiene Rubber",
    icon: "ri-oil-line",
    color: "bg-primary-500",
    properties: {
      내열성: "★★★★☆ (최대 120℃)",
      내한성: "★★☆☆☆ (-30℃)",
      내후성: "★★☆☆☆",
      내오존성: "★★☆☆☆",
      내유성: "★★★★★",
      내마모성: "★★★★☆",
      인장강도: "★★★★☆ (10~25 MPa)",
    },
    features: [
      "내유성과 내용제성이 탁월",
      "기계적 강도와 내마모성 우수",
      "아크릴로니트릴 함량 조절로 물성 조정 가능",
      "가스 투과성이 낮음",
    ],
    applications: ["오일씰, 연료호스", "유압기기 패킹", "산업용 롤러", "연료탱크 가스켓", "내유성 패킹"],
    desc: "내유성이 요구되는 환경에서 가장 많이 사용되는 고무 소재입니다. 아크릴로니트릴(ACN) 함량에 따라 내유성과 내한성의 균형을 조절할 수 있어 다양한 오일 및 연료 환경에 대응 가능합니다.",
  },
  {
    code: "CR",
    name: "CR (클로로프렌 고무)",
    fullName: "Chloroprene Rubber (Neoprene)",
    icon: "ri-fire-line",
    color: "bg-secondary-500",
    properties: {
      내열성: "★★★★☆ (최대 120℃)",
      내한성: "★★★☆☆ (-40℃)",
      내후성: "★★★★☆",
      내오존성: "★★★★☆",
      내유성: "★★★☆☆",
      내마모성: "★★★★☆",
      인장강도: "★★★★☆ (15~25 MPa)",
    },
    features: [
      "내후성, 내오존성, 내열성 균형 우수",
      "난연성이 있어 화재 안전 요구 환경에 적합",
      "접착성이 좋아 금속과의 접합에 유리",
      "내유성과 내약품성 보유",
    ],
    applications: ["방진 고무", "컨베이어 벨트", "건축용 가스켓", "케이블 시스", "접착제"],
    desc: "균형 잡힌 물성을 가진 다목적 고무 소재입니다. 특히 난연성을 갖추고 있어 건축, 선박, 광산 등 화재 안전이 중요한 환경에서 널리 사용됩니다.",
  },
  {
    code: "SBR",
    name: "SBR (스티렌 부타디엔 고무)",
    fullName: "Styrene Butadiene Rubber",
    icon: "ri-caravan-line",
    color: "bg-foreground-500",
    properties: {
      내열성: "★★★☆☆ (최대 100℃)",
      내한성: "★★★☆☆ (-50℃)",
      내후성: "★★☆☆☆",
      내오존성: "★★☆☆☆",
      내유성: "★☆☆☆☆",
      내마모성: "★★★★★",
      인장강도: "★★★☆☆ (5~20 MPa)",
    },
    features: ["내마모성이 매우 우수", "가공성과 경제성이 뛰어남", "충진제 배합으로 물성 조절 용이", "가격 경쟁력 우수"],
    applications: ["타이어 트레드", "신발 밑창", "컨베이어 벨트", "일반 산업용 고무제품", "방진 패드"],
    desc: "가장 경제적인 범용 고무 소재로, 특히 내마모성이 요구되는 용도에 적합합니다. 천연고무의 대체 소재로 널리 사용되며, 카본블랙 배합을 통해 기계적 물성을 크게 향상시킬 수 있습니다.",
  },
  {
    code: "FKM",
    name: "FKM (불소 고무 / Viton)",
    fullName: "Fluoroelastomer (Viton®)",
    icon: "ri-test-tube-line",
    color: "bg-accent-500",
    properties: {
      내열성: "★★★★★ (최대 250℃)",
      내한성: "★★☆☆☆ (-20℃)",
      내후성: "★★★★★",
      내오존성: "★★★★★",
      내유성: "★★★★★",
      내마모성: "★★★☆☆",
      인장강도: "★★★☆☆ (8~15 MPa)",
    },
    features: [
      "초고온·극한 화학 환경에서 최고 성능",
      "거의 모든 화학물질에 대한 내성 보유",
      "장기 내구성과 신뢰성 최상",
      "진공 환경에서도 아웃가싱 최소",
    ],
    applications: ["화학플랜트 씰", "반도체 장비 씰", "항공우주 부품", "고온 밸브 시트", "원자력 설비 가스켓"],
    desc: "극한의 온도와 화학 환경을 견디는 최고급 특수 고무 소재입니다. 가격은 높지만 타 소재로 대체 불가능한 극한 환경에서 필수적으로 사용됩니다. 당사는 FKM 소재의 압축성형에 특화된 생산라인을 운영하고 있습니다.",
  },
  {
    code: "VMQ",
    name: "실리콘 고무 (VMQ)",
    fullName: "Silicone Rubber (VMQ)",
    icon: "ri-cpu-line",
    color: "bg-secondary-500",
    properties: {
      내열성: "★★★★★ (최대 230℃)",
      내한성: "★★★★★ (-100℃)",
      내후성: "★★★★★",
      내오존성: "★★★★★",
      내유성: "★★☆☆☆",
      내마모성: "★★☆☆☆",
      인장강도: "★★☆☆☆ (4~10 MPa)",
    },
    features: [
      "극저온~고온까지 가장 넓은 사용 온도 범위",
      "생체 적합성 우수 (의료용 등급)",
      "전기 절연성 탁월",
      "투명/반투명 성형 가능",
    ],
    applications: ["의료기기 부품", "전기전자 절연 씰", "식품가공 장비 패킹", "방수 씰 (IP67/68)", "베이비 케어 제품"],
    desc: "인체 무해성과 넓은 사용 온도 범위가 특징인 고기능성 소재입니다. 의료, 식품, 전기전자 등 고순도가 요구되는 분야에서 필수적으로 사용되며, 당사는 식품 등급 및 의료 등급 실리콘 고무 성형이 가능합니다.",
  },
];

export const technicalDownloads = [
  {
    id: "td-001",
    title: "고무 소재 특성 비교표 (EPDM vs NBR vs CR vs FKM)",
    category: "기술자료",
    fileType: "PDF",
    fileSize: "2.4 MB",
    date: "2025-03-15",
  },
  {
    id: "td-002",
    title: "압축성형 공정 가이드라인",
    category: "공정기술",
    fileType: "PDF",
    fileSize: "1.8 MB",
    date: "2025-02-20",
  },
  {
    id: "td-003",
    title: "고무제품 치수 공차 기준 (KS M 6518)",
    category: "규격/표준",
    fileType: "PDF",
    fileSize: "3.1 MB",
    date: "2024-11-10",
  },
  {
    id: "td-004",
    title: "고무 경도 측정 방법 및 국제 규격 비교",
    category: "시험방법",
    fileType: "PDF",
    fileSize: "1.5 MB",
    date: "2024-09-05",
  },
  {
    id: "td-005",
    title: "고무 배합 기술 - 카본블랙과 충진제의 이해",
    category: "기술자료",
    fileType: "PDF",
    fileSize: "4.2 MB",
    date: "2024-07-18",
  },
  {
    id: "td-006",
    title: "실리콘 고무 특성 및 응용 분야 기술 보고서",
    category: "소재기술",
    fileType: "PDF",
    fileSize: "2.9 MB",
    date: "2024-05-22",
  },
  {
    id: "td-007",
    title: "고무 제품 내구성 시험 (KS M ISO 188)",
    category: "시험방법",
    fileType: "PDF",
    fileSize: "1.7 MB",
    date: "2024-03-30",
  },
  {
    id: "td-008",
    title: "O-Ring 설계 가이드 및 홈 치수 표준",
    category: "설계자료",
    fileType: "PDF",
    fileSize: "5.6 MB",
    date: "2024-01-15",
  },
];

export const supportNotices = [
  {
    id: "notice-001",
    title: "2025년 하계 휴가 일정 및 납품 일정 안내",
    date: "2025-06-20",
    important: true,
    content:
      "당사는 2025년 7월 28일(월)부터 8월 1일(금)까지 하계 휴가 기간입니다. 해당 기간 중 납품이 예정된 고객사께서는 사전에 일정 조율을 부탁드립니다.",
  },
  {
    id: "notice-002",
    title: "ISO 9001:2025 전환 심사 완료",
    date: "2025-05-10",
    important: false,
    content: "당사는 2025년 4월 28일 ISO 9001:2025 전환 심사를 성공적으로 완료하여 갱신 인증을 획득하였습니다.",
  },
  {
    id: "notice-003",
    title: "제3공장 증설 투자 계획 공지",
    date: "2025-03-25",
    important: true,
    content:
      "증가하는 수주 물량에 대응하기 위해 제3공장 증설 투자를 결정하였습니다. 2026년 상반기 완공을 목표로 추진 중이며, 완공 시 생산 능력이 현재 대비 40% 증가할 예정입니다.",
  },
  {
    id: "notice-004",
    title: "신규 압축성형 프레스 500톤 2기 도입 완료",
    date: "2025-02-14",
    important: false,
    content:
      "대형 고무제품 생산 능력 확대를 위해 500톤급 압축성형 프레스 2기를 추가 도입하였습니다. 이로써 대형 제품에 대한 납기 단축과 추가 수주가 가능해졌습니다.",
  },
  {
    id: "notice-005",
    title: "2025년 설 연휴 배송 일정 안내",
    date: "2025-01-20",
    important: false,
    content: "설 연휴 기간(1월 25일~1월 30일) 중 배송이 중단됩니다. 연휴 전후 납품 희망 고객사께서는 1월 18일까지 주문을 완료해 주시기 바랍니다.",
  },
];

export const dataRoomItems = [
  {
    id: "data-001",
    title: "한국고무공업 회사소개서 (2025)",
    category: "회사자료",
    fileType: "PDF",
    fileSize: "8.2 MB",
    date: "2025-04-01",
  },
  {
    id: "data-002",
    title: "주요 제품 카탈로그 - 산업용 고무부품",
    category: "제품자료",
    fileType: "PDF",
    fileSize: "12.5 MB",
    date: "2025-03-01",
  },
  {
    id: "data-003",
    title: "주요 제품 카탈로그 - 자동차용 고무부품",
    category: "제품자료",
    fileType: "PDF",
    fileSize: "10.8 MB",
    date: "2025-03-01",
  },
  {
    id: "data-004",
    title: "공장 보유 설비 리스트 및 생산 능력",
    category: "설비자료",
    fileType: "PDF",
    fileSize: "3.6 MB",
    date: "2024-12-15",
  },
  {
    id: "data-005",
    title: "품질경영 매뉴얼 (ISO 9001)",
    category: "품질자료",
    fileType: "PDF",
    fileSize: "5.1 MB",
    date: "2024-10-20",
  },
  {
    id: "data-006",
    title: "환경경영 매뉴얼 (ISO 14001)",
    category: "품질자료",
    fileType: "PDF",
    fileSize: "4.8 MB",
    date: "2024-09-10",
  },
];

export const quotationGuide = {
  title: "견적문의 안내",
  desc: "고객님의 요구사항을 정확히 파악하여 최적의 견적을 신속하게 제공해 드립니다. 아래 항목을 기재하여 문의해 주시면 보다 정확한 견적 산출이 가능합니다.",
  requiredInfo: [
    "제품 도면 또는 스케치 (PDF, DWG, JPG 가능)",
    "필요 수량 (월 예상 소요량)",
    "적용 환경 (온도, 접촉 유체, 압력 등)",
    "요구 물성 (경도, 인장강도, 내열온도 등)",
    "희망 납기",
  ],
  process: [
    { step: 1, title: "문의 접수", desc: "전화, 이메일, 또는 견적문의 게시판을 통한 접수" },
    { step: 2, title: "도면 검토", desc: "엔지니어의 도면/사양 검토 및 소재 추천" },
    { step: 3, title: "견적서 발송", desc: "2~3 영업일 이내 견적서 이메일 발송" },
    { step: 4, title: "협의 및 조정", desc: "수량·납기·사양 협의 및 최종 견적 확정" },
  ],
};